import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "@/pages/auth/AuthShell";
import { useI18n } from "@/context/I18nContext";
import api from "@/lib/api";

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { toast.error(t("common.error")); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title={t("auth.forgotTitle")} subtitle={t("auth.forgotSub")}>
      {sent ? (
        <div className="text-center space-y-4" data-testid="forgot-sent">
          <p className="text-sm text-muted-foreground">{t("auth.checkEmail")}</p>
          <Link to="/login" className="text-primary text-sm font-medium">{t("auth.backToLogin")}</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div className="space-y-2">
            <Label htmlFor="email">{t("common.email")}</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
          </div>
          <Button type="submit" className="w-full rounded-full" disabled={loading} data-testid="forgot-submit">
            {loading ? t("common.loading") : t("auth.sendLink")}
          </Button>
          <p className="text-center text-sm"><Link to="/login" className="text-primary">{t("auth.backToLogin")}</Link></p>
        </form>
      )}
    </AuthShell>
  );
}
